export default "__VITE_ASSET__DS0ubU7Q__"